import "@/App.css";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Layout from "@/components/site/Layout";
import Seo from "@/components/site/Seo";
import { Logo } from "@/components/site/Logo";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Teams from "@/pages/Teams";
import TeamDetail from "@/pages/TeamDetail";
import Players from "@/pages/Players";
import PlayerRegister from "@/pages/PlayerRegister";
import PlayerProfile from "@/pages/PlayerProfile";
import Fixtures from "@/pages/Fixtures";
import MatchCentre from "@/pages/MatchCentre";
import { Venues, VenueDetail } from "@/pages/Venues";
import Franchise from "@/pages/Franchise";
import Sponsors from "@/pages/Sponsors";
import Media from "@/pages/Media";
import { News, NewsArticle } from "@/pages/News";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLayout from "@/admin/AdminLayout";
import Overview from "@/admin/Overview";
import Enquiries from "@/admin/Enquiries";
import ContentManager from "@/admin/ContentManager";
import SettingsPage from "@/admin/SettingsPage";
import UsersPage from "@/admin/UsersPage";

const AuthScope = () => <ClerkAuthProvider><Outlet /></ClerkAuthProvider>;

const AuthPage = ({ children }) => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-8 px-4 py-12">
    <Seo title="Admin sign in" noindex />
    <Logo testid="auth-logo" />
    {children}
    <p className="max-w-sm text-center text-xs text-slate-500">Admin access only. Accounts receive dashboard access after a league administrator assigns a role.</p>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="teams" element={<Teams />} />
            <Route path="teams/:slug" element={<TeamDetail />} />
            <Route path="players" element={<Players />} />
            <Route path="players/register" element={<PlayerRegister />} />
            <Route path="players/:id" element={<PlayerProfile />} />
            <Route path="fixtures/match/:id" element={<MatchCentre />} />
            <Route path="fixtures/:tab?" element={<Fixtures />} />
            <Route path="venues" element={<Venues />} />
            <Route path="venues/:slug" element={<VenueDetail />} />
            <Route path="franchise" element={<Franchise />} />
            <Route path="sponsors" element={<Sponsors />} />
            <Route path="media" element={<Media />} />
            <Route path="news" element={<News />} />
            <Route path="news/:slug" element={<NewsArticle />} />
            <Route path="contact" element={<Contact />} />
            {["privacy-policy", "terms", "cookie-policy", "disclaimer"].map((p) => <Route key={p} path={p} element={<Legal />} />)}
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route element={<AuthScope />}>
            <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
            <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Overview />} />
              <Route path="enquiries/:kind" element={<Enquiries />} />
              <Route path="content/:coll" element={<ContentManager />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="users" element={<UsersPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
